// extracted by mini-css-extract-plugin
export default {"list":"AvatarGroup--list---ZVBY","list-item":"AvatarGroup--list-item--6FX3S","listItem":"AvatarGroup--list-item--6FX3S","avatar":"AvatarGroup--avatar--8ZPsx"};